// extracted by mini-css-extract-plugin
export var wrapper = "CartButton-module--wrapper--3_RaL";
export var spinAround = "CartButton-module--spinAround--2EQl3";